import { Suspense } from 'react'
import dynamic from 'next/dynamic'

// Using lazy-loaded components because @rails/actioncable dependency breaks SSR on import.
const ChatNotifications = dynamic(
  () => import('../ChatNotifications').then(module => module.default),
  { ssr: false },
)

const InboxNotifications = dynamic(
  () => import('../InboxNotifications').then(module => module.default),
  { ssr: false },
)

type Props = {
  websocketHostUrl?: string
}

const WebsocketChannels = ({ websocketHostUrl }: Props) => {
  if (!websocketHostUrl) return null

  return (
    <Suspense fallback={null}>
      <ChatNotifications url={websocketHostUrl} />
      <InboxNotifications url={websocketHostUrl} />
    </Suspense>
  )
}

export default WebsocketChannels
